import { render, staticRenderFns } from "./AppCardText.vue?vue&type=template&id=067ff278"
import script from "./AppCardText.vue?vue&type=script&lang=js"
export * from "./AppCardText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports